import TableCellFilted from '../common/componentUI/TableCellFilted';
import escalationWorklistDispatcher from './action';
import GroupToolbar from './component/GroupToolbar';
import ModalUpdateStatus from './component/ModalUpdateStatus';
import {
  COLUMN_ESCALATION_WORKLIST,
  DOWNLOAD_STATUS_DISPLAY,
  ESCALATION_WORKLISTS_COLORS,
  FUT_RESULT_DISPLAY,
  IR_RESULT_DISPLAY,
  REVIEW_STATUS_DISPLAY,
  WORKLIST_STATUSES_DISPLAY,
} from './constants';
import {
  ConfirmIcon,
  EditIcon,
  RegenerateIcon,
  WarningIcon,
} from '@/assets/svg';
import { handleSelectAll, objectToArray } from '@/helpers';
import CustomMenu from '@/new-components/CustomMenu';
import CustomMenuActions from '@/new-components/CustomMenuActions';
import ModalConfirmation from '@/new-components/CustomModal/ModalConfirmation';
import customToast from '@/new-components/CustomNotification';
import CustomPaperContainer from '@/new-components/CustomPaperContainer';
import CustomHeader from '@/new-components/CustomPaperContainer/CustomHeader';
import CustomTable from '@/new-components/CustomTable';
import CustomTooltip from '@/new-components/CustomTooltip';
import { StatusComponent } from '@/new-components/StatusComponent';
import {
  Box,
  Button,
  IconButton,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
} from '@material-ui/core';
import { ArrowDropDown, MoreVertRounded } from '@material-ui/icons';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';

const CustomButton = withStyles({
  root: {
    '& .MuiButton-label': {
      fontSize: 14,
      minWidth: '130px',
    },
    '&.MuiButton-text': {
      padding: '0px',
    },
  },
})(Button);

const EscalationWorklist = () => {
  const { list: data, paging } = useSelector(
    (state) => state?.escalationWorklist
  );
  const [searchKey, setSearchKey] = useState('');
  const [sortOption, setSortOption] = useState({});
  const [filterOption, setFilterOption] = useState({
    worklistStatuses: ['WaitForUpdate', 'Unreachable'],
  });
  const [appointmentDate, setAppointmentDate] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElAction, setAnchorElAction] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
  const [type, setType] = useState('');
  const [typeModal, setTypeModal] = useState('');

  const onFilterOptionChange = (key) => (e, newValue) => {
    let value = e.target.value;

    switch (key) {
      case 'resultTypes':
        value = handleSelectAll(
          value,
          objectToArray(IR_RESULT_DISPLAY).map((item) => item.key),
          filterOption.resultTypes
        );
        break;
      case 'reviewStatuses':
        value = handleSelectAll(
          value,
          objectToArray(REVIEW_STATUS_DISPLAY).map((item) => item.key),
          filterOption.reviewStatuses
        );
        break;
      case 'worklistStatuses':
        value = handleSelectAll(
          value,
          objectToArray(WORKLIST_STATUSES_DISPLAY).map((item) => item.key),
          filterOption.worklistStatuses
        );
        break;
      case 'downloadStatuses':
        value = handleSelectAll(
          value,
          objectToArray(DOWNLOAD_STATUS_DISPLAY).map((item) => item.key),
          filterOption.downloadStatuses
        );
        break;
      case 'screeningResults':
        value = handleSelectAll(
          value,
          objectToArray(FUT_RESULT_DISPLAY).map((item) => item.key),
          filterOption.screeningResults
        );
        break;

      default:
        break;
    }

    setFilterOption({
      ...filterOption,
      [key]: value,
    });
  };

  const fetchData = async (
    search = searchKey,
    pagingData = paging,
    sortOptionData = sortOption,
    filterOptionData = filterOption
  ) => {
    escalationWorklistDispatcher.getData(
      search,
      pagingData,
      sortOptionData,
      filterOptionData
    );
  };

  const debounceLoadData = useCallback(
    debounce((searchKey, paging, sortOption, filterOption) => {
      fetchData(
        searchKey,
        {
          pageIndex: 0,
          pageSize: paging.pageSize,
        },
        sortOption,
        filterOption
      );
    }, 500),
    []
  );

  useEffect(() => {
    debounceLoadData(searchKey, paging, sortOption, filterOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey, sortOption, filterOption]);

  const onResetFilterOps = () => {
    setFilterOption({});
    setAppointmentDate([]);
  };

  const onUpdateStatus = (type, params) => {
    escalationWorklistDispatcher.updateStatusWorklists(
      selectedItem.paxScreeningId,
      {
        worklistStatus: type,
        ...params,
      },
      () => {
        setShowModal(false);
        setShowUpdateStatusModal(false);
        setType('');
        fetchData(searchKey, paging, sortOption, filterOption);
        customToast(
          'success',
          "Escalation worklist's status has been successfully updated.",
          'Escalation worklist updated'
        );
      }
    );
  };

  const TableHeader = () => (
    <TableHead>
      <TableRow>
        {COLUMN_ESCALATION_WORKLIST.map((item) =>
          item.sortBy ? (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              sortBy="Date"
              sortOption={sortOption}
              onSortChange={() => {
                let newSortOption = {
                  sortBy: item.sortBy,
                  orderBy: sortOption.orderBy !== 'Asc' ? 'Asc' : 'Desc',
                };
                setSortOption(newSortOption);
              }}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          ) : (
            <TableCellFilted
              key={item.stateValue}
              label={item.label}
              stateValue={item.stateValue}
              style={{
                minWidth: item.minWidth || 'unset',
                width: item.width || 'unset',
              }}
              isHidden={false}
            />
          )
        )}
      </TableRow>
    </TableHead>
  );

  const renderDateTime = (row) => {
    let startDateFormat, startTimeFormat;
    const { date } = row;

    if (!date) return null;

    startDateFormat = moment(date).format('DD/MM/YYYY');
    startTimeFormat = moment(date).format('LT');
    return `${startDateFormat} ${startTimeFormat}`;
  };

  const renderTableBody = (row) => {
    return (
      <>
        <TableCell>
          <CustomTooltip content={row.fullName || '—'} />
        </TableCell>
        <TableCell>{row.identityNumber || '—'}</TableCell>
        <TableCell>{row.gender || '—'}</TableCell>
        <TableCell>{renderDateTime(row)}</TableCell>

        <TableCell>
          <Box display="flex" alignItems="center">
            {row.resultType ? (
              <StatusComponent
                filterList={IR_RESULT_DISPLAY}
                filterListColor={ESCALATION_WORKLISTS_COLORS}
                status={row.resultType}
              />
            ) : (
              ''
            )}

            {row.regenerateNote && (
              <CustomTooltip content={row.regenerateNote}>
                <WarningIcon
                  width={16}
                  height={16}
                  style={{
                    marginLeft: 4,
                    cursor: 'pointer',
                    fill: '#DB3D49',
                    color: '#DB3D49',
                  }}
                />
              </CustomTooltip>
            )}
          </Box>
        </TableCell>
        <TableCell>
          <StatusComponent
            filterList={DOWNLOAD_STATUS_DISPLAY}
            filterListColor={ESCALATION_WORKLISTS_COLORS}
            status={row.downloadStatus}
          />
        </TableCell>

        <TableCell>
          {row.screeningResult ? (
            <StatusComponent
              filterList={FUT_RESULT_DISPLAY}
              filterListColor={ESCALATION_WORKLISTS_COLORS}
              status={row.screeningResult}
            />
          ) : (
            '—'
          )}
        </TableCell>
        <TableCell>
          {row.worklistStatus === 'WaitForUpdate' ? (
            <CustomButton
              variant="text"
              color="primary"
              endIcon={<ArrowDropDown />}
              onClick={(e) => {
                setAnchorEl(e.currentTarget);
                setSelectedItem(row);
              }}
            >
              Update status
            </CustomButton>
          ) : (
            <StatusComponent
              filterList={WORKLIST_STATUSES_DISPLAY}
              filterListColor={ESCALATION_WORKLISTS_COLORS}
              status={row.worklistStatus}
            />
          )}
        </TableCell>
        <TableCell>
          <CustomTooltip content={row.reason || '—'} />
        </TableCell>
        <TableCell>
          <CustomTooltip content={row.reason2 || '—'} />
        </TableCell>
        <TableCell>
          <IconButton
            disabled={row.worklistStatus === 'WaitForUpdate'}
            onClick={(e) => {
              setAnchorElAction(e.currentTarget);
              setSelectedItem(row);
            }}
          >
            <MoreVertRounded />
          </IconButton>
        </TableCell>
      </>
    );
  };

  const listUpdateStatusActions = [
    {
      key: 'contacted',
      icon: () => (
        <Box width={20} height={20} bgcolor="#0B8E5E" borderRadius={4} />
      ),
      label: 'Contacted',
      onClick: () => {
        setType('Contacted');
        setShowModal(true);
        setAnchorEl(null);
        setTypeModal('Add');
      },
    },
    {
      key: 'unreachable1',
      icon: () => (
        <Box width={20} height={20} bgcolor="#DB3D49" borderRadius={4} />
      ),
      label: 'Unreachable + 1',
      onClick: () => {
        setType('Unreachable');
        setShowModal(true);
        setAnchorEl(null);
        setTypeModal('Add');
      },
    },
    {
      key: 'unreachable2',
      icon: () => (
        <Box width={20} height={20} bgcolor="#E37F2A" borderRadius={4} />
      ),
      label: 'Unreachable + 2',
      onClick: () => {
        setType('UnreachableAttempt2');
        setShowModal(true);
        setAnchorEl(null);
        setTypeModal('Add');
      },
    },
  ];

  const renderListActions = () => {
    if (!selectedItem) return [];

    let listActions = [
      {
        key: 'edit',
        icon: EditIcon,
        label: 'Edit note',
        styles: { width: 20, height: 20 },
        onClick: () => {
          setAnchorElAction(null);
          setShowModal(true);
          setType(selectedItem.worklistStatus);
          setTypeModal('Edit');
        },
      },
    ];

    if (selectedItem.worklistStatus === 'Unreachable') {
      listActions.push({
        key: 'changeStatus',
        icon: RegenerateIcon,
        label: 'Change to Unreachable + 2',
        onClick: () => {
          setAnchorElAction(null);
          setShowUpdateStatusModal(true);
          setType('UnreachableAttempt2');
        },
      });
      listActions.push({
        key: 'changeToContacted',
        icon: RegenerateIcon,
        label: 'Change to Contacted',
        onClick: () => {
          setAnchorElAction(null);
          setShowUpdateStatusModal(true);
          setType('Contacted');
        },
      });
    }

    if (selectedItem.worklistStatus === 'UnreachableAttempt2') {
      listActions.push({
        key: 'changeToContacted',
        icon: RegenerateIcon,
        label: 'Change to Contacted',
        onClick: () => {
          setAnchorElAction(null);
          setShowUpdateStatusModal(true);
          setType('Contacted');
        },
      });
    }
    return listActions;
  };

  return (
    <>
      <CustomMenu
        id="simple-menu"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <CustomMenuActions listActions={listUpdateStatusActions} />
      </CustomMenu>

      <CustomMenu
        id="action-menu"
        open={Boolean(anchorElAction)}
        anchorEl={anchorElAction}
        onClose={() => setAnchorElAction(null)}
      >
        <CustomMenuActions listActions={renderListActions()} />
      </CustomMenu>
      <CustomPaperContainer
        header={
          <CustomHeader
            searchPlaceholder="Search by name or ID number..."
            title="Escalation Worklist"
            setSearchKey={setSearchKey}
            searchKey={searchKey}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
            sortOption={sortOption}
            fetchData={fetchData}
            renderToolbar={() => (
              <GroupToolbar
                filterOption={filterOption}
                setFilterOption={setFilterOption}
                onResetFilterOps={onResetFilterOps}
                appointmentDate={appointmentDate}
                setAppointmentDate={setAppointmentDate}
                onFilterOptionChange={onFilterOptionChange}
              />
            )}
          />
        }
      >
        <CustomTable
          data={data}
          paging={paging}
          header={TableHeader}
          renderRow={(row) => renderTableBody(row)}
          noDataHelperText="No escalation worklist data"
          noDataHelperSubText="Please come back at another time."
          totalCols={COLUMN_ESCALATION_WORKLIST.length}
          fetchData={fetchData}
        />
      </CustomPaperContainer>
      {showModal && (
        <ModalUpdateStatus
          type={type}
          open={showModal}
          onClose={() => setShowModal(false)}
          onSubmit={(reason) => onUpdateStatus(type, reason)}
          selectedItem={selectedItem}
          typeModal={typeModal}
        />
      )}
      {showUpdateStatusModal && (
        <ModalConfirmation
          open={showUpdateStatusModal}
          onClick={() => {
            setShowUpdateStatusModal(false);
            if (type === 'Contacted') {
              setType('Contacted');
            } else {
              setType('UnreachableAttempt2');
            }
            setShowModal(true);
            setTypeModal('ChangeStatus');
          }}
          onClose={() => setShowUpdateStatusModal(false)}
          mainContent={'Update status'}
          subContent={
            type === 'Contacted'
              ? 'Are you sure you want to change this worklist to Contacted?'
              : 'Are you sure you want to change this worklist to Unreachable + 2?'
          }
          cancelLabel="No"
          confirmLabel="Yes"
          Icon={<ConfirmIcon />}
        />
      )}
    </>
  );
};

export default EscalationWorklist;
